export default __webpack_public_path__ + "static/media/ca0c78454b049fd4761d70f770c40615.jpg";